import { Link } from "react-router-dom";
import { Linkedin } from "lucide-react";

const NAV = [
  ["Research", "/research"],
  ["Practice", "/practice"],
  ["Community", "/community"],
  ["About", "/about"],
];

export function Footer() {
  return (
    <footer className="border-t border-line bg-white" data-testid="site-footer">
      <div className="mx-auto max-w-[1400px] px-6 md:px-12 py-9 md:py-12">
        <div className="flex flex-col md:flex-row md:items-center justify-between gap-6">
          <Link to="/" data-testid="footer-logo" className="flex items-center gap-2.5 font-serif text-xl md:text-2xl tracking-tight font-medium">
            <img src="/images/logo.png" alt="Mentheris logo" className="h-7 md:h-8 w-auto" />
            <span>Mentheris<span className="text-ember">.</span></span>
          </Link>
          <nav className="flex flex-wrap items-center gap-x-7 gap-y-3" data-testid="footer-nav">
            {NAV.map(([label, to]) => (
              <Link
                key={to}
                to={to}
                data-testid={`footer-link-${label.toLowerCase()}`}
                className="link-editorial text-sm text-ink/70 hover:text-ink transition-colors duration-300"
              >
                {label}
              </Link>
            ))}
            <a
              href="mailto:contact@mentheris.com"
              data-testid="footer-email-link"
              className="link-editorial text-sm text-ink/70 hover:text-ink transition-colors duration-300"
            >
              Contact
            </a>
          </nav>
        </div>

        <div className="flex flex-col md:flex-row md:items-center justify-between gap-3 border-t border-line mt-6 pt-5">
          <p className="text-xs text-fog">Copyright © 2026 Mentheris · All Rights Reserved.</p>
          <div className="flex items-center gap-4">
            <a
              href="https://www.linkedin.com/company/mentheris/"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-linkedin"
              aria-label="Mentheris on LinkedIn"
              className="text-fog hover:text-ember transition-colors duration-300"
            >
              <Linkedin size={16} />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
